import {
  withTranslation,
} from 'react-i18next';

import RegattaDocumentsSectionView from './RegattaDocumentsSectionView';

const TranslatedComponent = withTranslation()(RegattaDocumentsSectionView);

const Component = TranslatedComponent;

export default Component;
